import { TextField, InputAdornment, CircularProgress } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { ChangeEvent } from 'react';

interface GangMemberSearchInputProps {
  value: string;
  placeholder: string;
  isLoading: boolean;
  onChange: (value: string) => void;
}

export const GangMemberSearchInput = ({
  value,
  placeholder,
  isLoading,
  onChange,
}: GangMemberSearchInputProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <TextField
      fullWidth
      data-testid="user-search"
      placeholder={placeholder}
      inputProps={{
        'data-testid': 'gang-member-search-input',
      }}
      value={value}
      onChange={handleChange}
      sx={{ mb: 2 }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: isLoading ? (
            <InputAdornment position="end">
              <CircularProgress size={20} data-testid="user-search-loading" />
            </InputAdornment>
          ) : null,
        },
      }}
    />
  );
};
